import {
  aggregationResponseSchema,
  advisoryResponseSchema,
  annualSummaryResponseSchema,
  consolidatedPatrimoineSchema,
  forecastResponseSchema,
  propertyPatrimoineSchema,
  propertyValuationSchema,
  transactionSchema,
  type AggregationBucket,
  type LedgerQuery,
  type PropertyValuationInput,
} from '@app/shared';
import { z } from 'zod';
import { apiFetch } from '@/lib/api';

function toQueryString(params: Record<string, string | number | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) search.set(key, String(value));
  }
  const query = search.toString();
  return query === '' ? '' : `?${query}`;
}

export function fetchTransactions(filters: LedgerQuery) {
  return apiFetch(`/api/transactions${toQueryString(filters)}`, { schema: z.array(transactionSchema) });
}

export function fetchAggregations(filters: {
  bucket: AggregationBucket;
  propertyId?: number;
  dateFrom?: string;
  dateTo?: string;
}) {
  return apiFetch(`/api/ledger/aggregations${toQueryString(filters)}`, { schema: aggregationResponseSchema });
}

export function fetchAnnualSummary(year: number, propertyId?: number) {
  return apiFetch(`/api/ledger/annual-summary${toQueryString({ year, propertyId })}`, { schema: annualSummaryResponseSchema });
}

export function fetchPropertyValuations(propertyId: number) {
  return apiFetch(`/api/properties/${String(propertyId)}/valuations`, { schema: z.array(propertyValuationSchema) });
}

export function addPropertyValuation(propertyId: number, input: PropertyValuationInput) {
  return apiFetch(`/api/properties/${String(propertyId)}/valuations`, {
    method: 'POST',
    body: input,
    schema: propertyValuationSchema,
  });
}

export function fetchPropertyPatrimoine(propertyId: number) {
  return apiFetch(`/api/properties/${String(propertyId)}/patrimoine`, { schema: propertyPatrimoineSchema });
}

export function fetchConsolidatedPatrimoine() {
  return apiFetch('/api/patrimoine', { schema: consolidatedPatrimoineSchema });
}

export function fetchForecast(propertyId?: number) {
  return apiFetch(`/api/forecast${toQueryString({ propertyId })}`, { schema: forecastResponseSchema });
}

export function generateAdvisory(propertyId?: number) {
  return apiFetch('/api/forecast/advisory', { method: 'POST', body: { propertyId }, schema: advisoryResponseSchema });
}
